module.exports = __webpack_public_path__ + "img/H01120-01.347baccf.jpg";